import React from "react";
import { AlertOctagon } from "lucide-react";
import { ERROR_STRINGS } from "../constants/strings";
import { Button } from "../ui";

export default function ErrorFallback() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60dvh",
        textAlign: "center",
        padding: "0 24px",
        gap: 12,
      }}
    >
      <AlertOctagon size={64} style={{ color: "var(--err)" }} />
      <h1
        style={{
          fontFamily: "var(--serif)",
          fontWeight: 500,
          fontSize: 24,
          letterSpacing: "-0.018em",
          color: "var(--ink)",
          margin: 0,
        }}
      >
        {ERROR_STRINGS.TITLE}
      </h1>
      <p style={{ color: "var(--ink-3)", maxWidth: 400, margin: 0 }}>
        {ERROR_STRINGS.MESSAGE}
      </p>
      <Button onClick={() => window.location.reload()}>{ERROR_STRINGS.RELOAD}</Button>
    </div>
  );
}
